import React, { useRef } from "react";
import { NavLink } from 'react-router-dom';


import Intro from "./components/Intro/Intro";
import ImageSplit from "./components/ImageSplit/ImageSplit";
import IntroDescriptionOne from "./components/IntroDescriptionOne/IntroDescriptionOne";
import IntroDescriptionTwo from "./components/IntroDescriptionTwo/IntroDescriptionTwo";

import './IntroPage.css'

import { FaLink, FaRegFilePdf } from "react-icons/fa"


const IntroPage = function (props) {

    const descriptionRef = useRef();


    return (

        <React.Fragment>
            <Intro reference={descriptionRef} />





            <div className="page-body">
                <div className="page-content">
                    <div className="container-box">
                        <IntroDescriptionOne reference={descriptionRef} />

                    </div>

                </div>








                <div className="page-content">
                    <div className="container-box">
                        <ImageSplit />
                    </div>
                </div>




                <div className="page-content">
                    <div className="container-box">
                        <div className="intro-content">
                            <h1 className="intro-name"><span>Informationen</span></h1>
                            <p>
                                Combat Sports Lübeck e.V. ist die Adresse für Original Muaythai und RKC- Hardstyle Kettlebelltraining. Aus der Begeisterung zum Muaythai, seiner Effektivität, Härte und Überlegenheit entstand der Verein. Es wurde allerdings schnell klar, dass zielorientiertes Training, den Sportler fitter, stärker und gesunder zu machen viel mehr bedeutet. Zu jeder Sportart gehört ein “Fitnessprogramm” um die Schüler sportlich weiterzubringen und dabei die Leistung zu steigern. Das RKC-Hardstyle Trainingsprinzip mit den Kettlebells ist für jeden intensiv trainierenden Kampf-oder Kraftsportler das mit Abstand durchdachteste und beste Kraft -und Konditionstraining. Leistungsfähigkeit, Kraftausdauer, Maximalkraft, Power, Stabilität und Agilität werden durch diese Trainingsform sehr effizient gleichzeitig entwickelt.
                            </p>
                            <p>
                                Wir trainieren nach dem Prinzip Bewegungsqualität vor Bewegungsquantität. Bandscheibenvorfälle, schmerzende Schultern und kaputte Knie gehören bei uns der Vergangenheit an. Mehr Kraft, mehr Ausdauer, mehr Beweglichkeit und unendlich viele Trainingsmöglichkeiten findest Du bei uns auf 200m² Playground.
                            </p>
                        </div>
                        <div className="intro-description-intro-flex-container">
                            <div className="intro-descript-One-flex-left-same-as-right">
                                <div className="intro-content">
                                    <h2 className="intro-intro"><span>Was wir bieten:</span></h2>
                                    <ul class="cs-list">
                                        <li>Wir haben 24/7 geöffnet</li>
                                        <li>5 Tage die Woche Muay Thai/K1 Training </li>
                                        <li>ausreichend Langhanteln und 11 Racks</li>
                                        <li>Dragon Door Kettlebells bis 60kg</li>
                                        <li>Kurzhanteln bis 75kg</li>
                                        <li>Farmers Walk Handles, Schlitten, Yoke</li>
                                        <li>Und noch vieles mehr...</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="intro-descript-One-flex-right">
                                <div className="intro-content">
                                    <h2 className="intro-intro"><span>Was uns wichtig ist:</span></h2>
                                    <p>
                                        Bei Combat Sports Lübeck e.V. begreifen wir, dass es im Leben mehr als nur Kampf- und Kraftsport gibt. Was wirklich zählt, ist die Gemeinschaft, die wir aufbauen und gemeinsam entwickeln. Unsere Mitglieder investieren nicht nur in ein Sportangebot, sondern in eine sich unterstützende Gemeinschaft, die auf Respekt und Zusammenhalt basiert.
                                    </p>
                                    <p>
                                        Als gemeinnütziger Verein setzen wir uns nicht nur für den Sport ein, sondern auch für die Stärkung von Werten wie Teamgeist, Disziplin und Fairness. Deine Mitgliedschaft bedeutet mehr als nur in ein Fitnessstudio zu gehen – sie ist eine Investition in ein Netzwerk von Gleichgesinnten, die sich gegenseitig inspirieren und unterstützen.
                                    </p>

                                </div>
                            </div>
                        </div>
                        <div className="intro-content">
                            <h2 className="intro-intro"><span>Kontakt</span></h2>
                            <p>
                                Haben wir dein Interesse geweckt? Dann nimmt doch  <NavLink className="underline cs-text-link" to="/impressum" exact="true"><FaLink className="icon-link-text " /> Kontakt</NavLink> zu uns auf und vereinbare ein Probetraining!
                            </p>
                        </div>


                    </div>

                </div>

            </div>







            {/* <div className="page-body">
                <div className="page-content">
                    <div className="promo" >
                        <div className="image-wrapper"><img src="https://images.unsplash.com/photo-1554620121-59e7f3f6e3a4?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=800&fit=max&ixid=eyJhcHBfaWQiOjE0NTg5fQ" /></div>
                        <h2 className="title" data-cta="Get out there TEST TEST→">Nightlife</h2>
                    </div>
                </div >
            </div > */}


            {/* <div className="page-body">
                <div className="page-content">

                    <IntroDescriptionTwo />

                </div>

            </div> */}








        </React.Fragment >
    )
}

export default IntroPage